function StatusLayout<TStatus extends string | number | symbol>(props: {
    status: TStatus;
    items: { default: JSX.Element } & Partial<Record<TStatus, JSX.Element>>;
}) {
    return props.items[props.status] || props.items.default;
}

export default StatusLayout;
